<template>
  <el-drawer title="风险处理" :visible="visible" size="56%" :before-close="beforeClose">
    <div v-if="risk" v-loading="loading" class="body">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="内容">{{ record.title || record.item_source_id }}</el-descriptions-item>
        <el-descriptions-item label="风险分类">{{ record.abnormal_category || '-' }}</el-descriptions-item>
        <el-descriptions-item label="建议动作">{{ detail.suggested_action || '-' }}</el-descriptions-item>
      </el-descriptions>
      <h4>命中证据</h4>
      <el-table :data="evidences" size="mini" empty-text="暂无可展示的风险证据">
        <el-table-column label="类型" width="80"><template slot-scope="s">{{ s.row.evidence_type === 'comment' ? '评论' : '原文' }}</template></el-table-column>
        <el-table-column prop="content_snapshot" label="正文" min-width="220" show-overflow-tooltip />
        <el-table-column prop="matched_terms" label="命中词" width="120" />
        <el-table-column prop="collected_at" label="采集时间" width="170" />
        <el-table-column label="链接" width="170"><template slot-scope="s"><a v-if="s.row.source_url" :href="s.row.source_url" target="_blank">原文</a><a v-if="s.row.comment_url" :href="s.row.comment_url" target="_blank"> · 评论</a><span v-else-if="s.row.evidence_type === 'comment'" class="muted">评论直链暂不支持</span></template></el-table-column>
      </el-table>
      <h4>处理记录</h4>
      <el-form label-width="90px" :disabled="saving">
        <el-form-item label="负责人"><el-input v-model="draft.assignee" /></el-form-item>
        <el-form-item label="处理状态"><el-select v-model="draft.process_status"><el-option v-for="status in statuses" :key="status" :value="status" /></el-select></el-form-item>
        <el-form-item label="处理备注"><el-input v-model="draft.process_note" type="textarea" /></el-form-item>
        <el-button type="primary" :loading="saving" @click="save">{{saving?'保存中':'保存处理记录'}}</el-button>
      </el-form>
      <h4>历史处理记录</h4>
      <el-table :data="detail.process_logs || []" size="mini" empty-text="暂无历史记录">
        <el-table-column prop="processed_at" label="时间" width="180" />
        <el-table-column prop="assignee" label="负责人" />
        <el-table-column prop="process_status" label="状态" />
        <el-table-column prop="process_note" label="备注" />
      </el-table>
    </div>
  </el-drawer>
</template>
<script>
import { yuqingApi } from '@/api/yuqing'
export default {
  props: ['visible', 'risk'],
  data () { return { loading: false, saving: false, detail: {}, draft: {}, statuses: ['待确认', '处理中', '已关闭', '误报'] } },
  computed: {
    record () { return this.detail.risk || this.risk || {} },
    evidences () {
      if (this.detail.evidences && this.detail.evidences.length) return this.detail.evidences
      if (!this.record.evidence_text) return []
      return [{ evidence_type: 'content', content_snapshot: this.record.evidence_text, matched_terms: this.record.matched_terms, source_url: this.record.source_url, collected_at: this.record.created_at }]
    }
  },
  watch: { visible (value) { if (value && this.risk) this.load() } },
  methods: {
    async load () { this.loading = true; try { this.detail = await yuqingApi.get(`risk-records/${this.risk.id}`); this.draft = { assignee: this.record.assignee || '', process_status: this.record.process_status || '待确认', process_note: this.record.process_note || '' } } catch (error) { this.$message.error(error.message) } finally { this.loading = false } },
    async save () {
      if (!this.risk || this.saving) return
      this.saving = true
      try {
        await yuqingApi.post(`risk-records/${this.risk.id}/process`, this.draft)
        this.$message.success('处理记录已保存')
        await this.load()
        this.$emit('saved')
      } catch (error) {
        this.$message.error(error.message || '处理记录保存失败')
      } finally {
        this.saving = false
      }
    },
    beforeClose (done) { if (!this.saving) { done(); this.$emit('update:visible', false) } }
  }
}
</script>
<style scoped>.body{padding:0 20px}.muted{color:#909399;font-size:12px}</style>
